module.exports = __webpack_public_path__ + "static/postopservice-255b3222cc54a2d079cfe81072aa085f.mp4";